export default __webpack_public_path__ + "static/media/TradeManager.f9fd9993.png";